import { render, staticRenderFns } from "./africanValueChain.vue?vue&type=template&id=c9142454&scoped=true&"
import script from "./africanValueChain.vue?vue&type=script&lang=js&"
export * from "./africanValueChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9142454",
  null
  
)

export default component.exports